import { useParams } from "react-router-dom";
import { Box } from "@mui/material";

import SEO from "../../components/commonComponents/SEO";

import { servicesData } from "../../data/servicesData";

import ServiceOfferCards from "../../components/service_page/ServiceOfferCards";
import ServiceWhyChoose from "../../components/service_page/ServiceWhyChoose";
import HeroBanner from "../../components/commonComponents/HeroBanner";
import ServiceDetailedSections from "../../components/service_page/ServiceDetailedSections";
import CommonCTA from "../../components/commonComponents/CommonCTA";
import BackgroundEffects from "../../components/commonComponents/BackgroundEffects";

import NotFoundPage from "../NotFoundPage";

const SITE_URL = "https://www.zencon-sa.com";

const ServicePage = () => {
  const { slug } = useParams();

  const service = servicesData[slug];

  if (!service) {
    return <NotFoundPage />;
  }

  const pageUrl = `${SITE_URL}/services/${slug}`;

  return (
    <>
      <SEO
        title={service.seo?.title || `${service.title} | ZENCON`}
        description={
          service.seo?.description || `${service.title} services by ZENCON`
        }
        keywords={service.seo?.keywords || `${service.title}, SAP Services`}
        url={pageUrl}
        image={
          service.seo?.image ||
          "https://www.zencon-sa.com/images/default-seo.png"
        }
      />

      <HeroBanner title={service.title} subtitle={service.subtitle} />

      <Box
        sx={{
          minHeight: "100vh",
          position: "relative",
          overflow: "hidden",
          background:
            "linear-gradient(135deg, #f7fbff 0%, #eef7f4 45%, #f8fbff 100%)",
        }}
      >
        <BackgroundEffects />

        <ServiceDetailedSections service={service} />

        <ServiceOfferCards service={service} />

        <ServiceWhyChoose service={service} />

        <CommonCTA />
      </Box>
    </>
  );
};

export default ServicePage;
